// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__2RFyj","logo":"layout_logo__3W2xy","user":"layout_user__oVCf_"};